import {
	BaseURL,
	ShouldLaunchApp,
	ShouldLaunchAppClip,
	ShouldAppClipsLaunchViaAppleLinks,
	launchApp,
	launchAppClip,
	ViewUtils,
	appClipsCapability,
	AppClipsCapability,
} from './Core'
import{ AppType, GLOBAL_AppPlatform, Metrics, Page, Platform, TriggerPoint } from './Metrics'
import{ RegionVM } from './Models/RegionVM'
import { ActionBar } from './Shared/ActionBar'


//
// region constants
//

declare const _region:RegionVM
declare const DEBUG_IncludePreviewData:boolean|undefined

let DEBUG_includePreviewData:boolean = (typeof(DEBUG_IncludePreviewData) !== 'undefined') && DEBUG_IncludePreviewData

// endregion


$( async function () {
	const actionBar = new ActionBar( Page.LandingPage )
	
	// observe history state
	window.addEventListener( 'popstate', (e:PopStateEvent) => {
		const state = e.state
 		if( state?.region !== null && state?.region !== undefined ){
			fetchRegion( state.region, true )
		} else {
			fetchRegion(/*default region:*/'Spain', true )
		}
	})
	
	// init
	$('.launchButtonContainer > .action-button').on( 'click', async event => {
		let ctaButton:JQuery<HTMLElement> = $(event.currentTarget)
		let href:string = ctaButton.attr( 'data-href' )

		await launchAppOrClip( href, TriggerPoint.PrimaryCTA )
	})
	
	$('.market-button').on( 'click', (e) => {
		let marketButton:JQuery<HTMLElement> = $(e.currentTarget)
		
		$('#destinations-container').hide()
		$('#destinations-loader').removeClass( 'd-none' )

		const region:string = marketButton.attr( 'data-id' )
		fetchRegion( region, false )
	})
	$('#mainCTA > a').on( 'click', async () => {
		let appType:AppType = (appClipsCapability == AppClipsCapability.Full) ? AppType.Transient : AppType.Permanent
		if( GLOBAL_AppPlatform == Platform.iOS ) // TEMP: workaround for Amplitude bug where filters are not respected when syncing
			await Metrics.logNAV_launchApp( appType, Page.RegionPage, TriggerPoint.SecondaryCTA )

		// navigate
		let href:string = $(`#mainCTA > a`).attr( 'data-href' )
		// console.debug( `CTA HREF: ${href}` )
		await Metrics.flush() // NOTE: ensure metrics are pushed before navigating away
		window.location.href = href
	})
	$('#destinations-list .destination-card .cta-button').on( 'click', async (e) => {
		let destinationLaunchButton:JQuery<HTMLElement> = $(e.currentTarget)
		e.stopPropagation() // NOTE: needed to prevent parent card click

		// launch event
		let appType:AppType = (appClipsCapability == AppClipsCapability.Full) ? AppType.Transient : AppType.Permanent
		if( GLOBAL_AppPlatform == Platform.iOS ) // TEMP: workaround for Amplitude bug where filters are not respected when syncing
			await Metrics.logNAV_launchApp( appType, Page.LandingPage, TriggerPoint.ListItem )

		// navigate
		let href:string = destinationLaunchButton.attr( 'data-href' )
		// console.debug( `LIST ITEM HREF: ${href}` )
		await Metrics.flush() // NOTE: ensure metrics are pushed before navigating away
		window.location.href = href
	})
	fetchPosts()
	
	function fetchRegion( region:string, isHistoryPop:boolean ) {
		for( const marketButtonElement of $('.market-button') ){
			let marketButton:JQuery<HTMLElement> = $(marketButtonElement)
			if( marketButton.attr( 'data-id' ) !== region ){
				marketButton.removeClass( 'active' )
			} else {
				marketButton.addClass( 'active' )
			}
		}

		// fetch data
		const previewPart:string = (DEBUG_includePreviewData) ? '&preview=true' : ''
		const url:string = `${BaseURL}/part/destinations-list?region=${region}${previewPart}`
		const historyURLParams:string = `?r=${region}${previewPart}`
		fetch( url, { method: 'GET' })
			.then( (result:Response) => result.text())
			.then( (htmlBlock:string) => {
				$('#destinations-list').html( htmlBlock )
				if( !isHistoryPop )
					history.pushState({ 'region': region }, null, historyURLParams )
			})
			.catch( (errorMessage:string) => {
				let snackbar:HTMLElement = document.getElementById( 'snackbar' )
				snackbar.classList.add( 'show' )
				setTimeout( () => {
					snackbar.classList.remove('show' )
				}, 3000 )
			})
			.finally(() => {
				// deactivate async UI
				$('#destinations-loader').addClass( 'd-none' )
				$('#destinations-container').show()
			})
	}

	// TODO(DRY): move into social posts component
	function fetchPosts( /*isHistoryPop:boolean*/ ) {
		const previewPart:string = (DEBUG_includePreviewData) ? '&preview=true' : ''
		const url:string = `${BaseURL}/part/social-posts?pageSize=16${previewPart}`
		fetch( url, { method: 'GET' })
			.then( (result:Response) => result.text())
			.then( (htmlBlock:string) => {
				$('#social-posts').html( htmlBlock )
				// if( !isHistoryPop )
				// 	history.pushState({ 'region': region }, null, historyURLParams )
			})
			.catch( (errorMessage:string) => {
				let snackbar:HTMLElement = document.getElementById( 'snackbar' )
				snackbar.classList.add( 'show' )
				setTimeout( () => {
					snackbar.classList.remove('show' )
				}, 3000 )
			})
			.finally(() => {
				// deactivate async UI
				$('#posts-loader').addClass( 'd-none' )
				$('#posts-container').show()
	
				initPosts()
			})
	}
	

	//
	// scroll triggers
	//
	const logoView:HTMLElement = $('#topLogo')[0]
	const destinationsHeadingView:HTMLElement = $('main > h1')[0]
	const preFooterView:HTMLElement = $('#__preFooter')[0]
	const footerView:HTMLElement = $('footer')[0]
	const valuePropsSection:HTMLElement = $('#value-props')[0]
	// CTA (top)
	ViewUtils.performWhenScrollingIntoView( destinationsHeadingView, () => {
		actionBar.show()
	})
	ViewUtils.performWhenScrollingIntoView( logoView, () => {
		// console.debug( 'Hide action bar (top)' )
		actionBar.hide()
	})
	// CTA (bottom)
	ViewUtils.performWhenScrollingIntoView( valuePropsSection, () => {
		actionBar.show()
	})
	ViewUtils.performWhenScrollingIntoView( [preFooterView, footerView], () => {
		console.debug( 'Hide action bar (bottom)' )
		actionBar.hide()
	})


	// TODO(DRY): move into social posts component
	function initPosts() {
		$('.post-item').on( 'click', async (e) => {
			let postItem:JQuery<HTMLElement> = $(e.currentTarget)

			let appType:AppType = (appClipsCapability == AppClipsCapability.Full) ? AppType.Transient : AppType.Permanent
			if( appType == AppType.Transient ) // NOTE: behaviour is only to launch for transient apps – otherwise continue to destination page
				await Metrics.logNAV_launchApp( appType, Page.LandingPage, TriggerPoint.ListItem )

			// navigate
			let href:string = postItem.attr( 'data-href' )
			// console.debug( `HREF: ${href}` )
			await Metrics.flush() // NOTE: ensure metrics are pushed before navigating away
			window.location.href = href
		})
	}
	
	async function launchAppOrClip( href:string, triggerPoint:TriggerPoint ){
		let appType:AppType = (appClipsCapability == AppClipsCapability.Full) ? AppType.Transient : AppType.Permanent
		if( GLOBAL_AppPlatform == Platform.iOS ) // TEMP: workaround for Amplitude bug where filters are not respected when syncing
			await Metrics.logNAV_launchApp( appType, Page.RegionPage, triggerPoint )

		// navigate
		console.debug( `Launching app (HREF: ${href}, trigger: ${triggerPoint})...` )
		await Metrics.flush() // NOTE: ensure metrics are pushed before navigating away
		window.location.href = href
	}
	

	// metrics
	Metrics.logLandingPageViewed( _region.Identifier )

	// app launch
	// TODO(DRY): generalize across pages
	await Metrics.logAppClipsCapability()
	if( ShouldLaunchAppClip ){
		if( ShouldAppClipsLaunchViaAppleLinks ){
			/*NOTE: ignore async*/await launchAppClip()
		} else { /*do nothing – handled via <meta> param*/ }
	} else if( ShouldLaunchApp ){
		/*NOTE: ignore async*/await launchApp()
	}
})
